// this is generated via google sheet json export
export default {
  seoTitle: "ATP Predictions, Odds & Analysis",
  news: {
    seoTitle: "ATP Sports Betting News | BetQL",
  },
  description:
    "Your #1 site for ATP predictions—daily ATP picks, expert matchup analysis, and real-time line movement.",
  "free-pick-predictions": {
    seoTitle: "Free ATP Picks | ATP Predictions | BetQL",
    h1: "BetQL Free ATP Picks",
  },
  odds: {
    seoTitle: "ATP Odds | ATP Point Spreads | BetQL",
    h1: "ATP Point Spreads",
    moneyline: {
      seoTitle: "ATP Money Lines | ATP Moneylines | BetQL",
      h1: "ATP Money Lines",
    },
    "totals-spread": {
      seoTitle: "ATP Over Unders | ATP Over Under Picks | BetQL",
      h1: "ATP Over Under Picks",
    },
    "first-half-lines": {
      seoTitle: "ATP 1st Half Spreads | ATP 1st Half Lines | BetQL",
      h1: "ATP 1st Half Spreads",
    },
    "second-half-lines": {
      seoTitle: "ATP Halftime Odds | ATP Halftime Lines | BetQL",
      h1: "ATP Halftime Spreads",
    },
  },
  "best-bets": {
    seoTitle: "ATP Spreads | ATP Odds | BetQL",
    h1: "ATP Trending Bets",
    description:
      "Check out BetQL for the latest ATP odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  "public-betting": {
    seoTitle: "ATP Public Betting | ATP Consensus Picks | BetQL",
    h1: "ATP Consensus Picks",
  },
  "sharp-picks": {
    seoTitle: "ATP Picks | ATP Expert Picks | BetQL",
    h1: "ATP Picks",
  },
  "line-movement": {
    seoTitle: "ATP Line Movement | ATP Betting Line Movement | BetQL",
    h1: "ATP Line Movement",
  },
};
